import React, { useState } from 'react';
import { X } from 'lucide-react';

interface MinimalWidgetProps {
  children: React.ReactNode;
  onClose?: () => void;
  className?: string;
}

const MinimalWidget: React.FC<MinimalWidgetProps> = ({
  children,
  onClose,
  className = '',
}) => {
  const [isHovering, setIsHovering] = useState(false);

  return (
    <div 
      className={`relative h-full w-full ${className}`}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {/* Close button that fades in when hovering */}
      {onClose && (
        <div 
          className={`absolute top-1 right-1 z-50 transition-all duration-200 ease-in-out ${isHovering ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}
          style={{ 
            transformOrigin: 'top right',
            pointerEvents: isHovering ? 'auto' : 'none'
          }}
        >
          <button 
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
            onMouseDown={(e) => e.stopPropagation()}
            className="p-1 rounded-full bg-black/70 hover:bg-black/90 text-gray-200 hover:text-white transition-colors cursor-pointer shadow-md isolate"
            title="Close Widget"
          >
            <X size={12} />
          </button>
        </div>
      )}

      {/* Widget Content */}
      <div className="h-full w-full">
        {children}
      </div>
    </div>
  );
};

export default MinimalWidget; 